// Guest consent is local to this browser; it does not create an account.
export const BETA_AGREEMENT_VERSION = 'beta-v2-2026-10-29'
const CONSENT_KEY = 'civitas_guest_agreement'
export function hasGuestAgreement() {
  try { return localStorage.getItem(CONSENT_KEY) === BETA_AGREEMENT_VERSION }
  catch { return false }
}
export function acceptGuestAgreement() {
  try { localStorage.setItem(CONSENT_KEY, BETA_AGREEMENT_VERSION) }
  catch { throw new Error('Enable browser storage to continue without an account.') }
}
